import { useMultipleQueryParamStates } from '#/hooks/useMultipleQueryParamStates';
import type { RoutePath } from '#/routing/classes/RoutePath';

export function useRouteSearchParams<
  T extends RoutePath<string, string, string, string>,
>(
  routePath: T,
): ReturnType<typeof useMultipleQueryParamStates<T['searchParams'][number]>> {
  return useMultipleQueryParamStates({
    names: routePath.searchParams,
    arrayNames: [],
  });
}
